
import { defineComponent, ref, onMounted } from 'vue'
import { Company } from '@/repositories/system/data'
import { repositories } from '@/repositories/system/repositories'
import ListContentLayout from '@/views/layout/ListContentLayout.vue'
import CompanyUpdateDialog from '@/views/system/CompanyUpdateDialog.vue'
import ConfirmDeleteModal from '@/views/modal/ConfirmDeleteModal.vue'
import { buildDefaultRequestErrorHandler } from '@/repositories/errorHandler'

const repository = repositories.company

type ModifyModalState = {
  showing: boolean;
  targetId: string | null;
}

type DeleteModalState = {
  showing: boolean;
  targetObj: Company | null;
  targetName: string | null;
}

export default defineComponent({
  components: {
    ConfirmDeleteModal,
    CompanyUpdateDialog,
    ListContentLayout
  },
  setup () {
    const requestError = ref<string | null>(null)
    const companies = ref<Company[]>([])
    const showingAddModal = ref(false)
    const modifyModal = ref<ModifyModalState>({
      showing: false,
      targetId: null
    })

    const deleteModal = ref<DeleteModalState>({
      showing: false,
      targetObj: null,
      targetName: null
    })

    onMounted(async () => {
      companies.value = await repository.list()
    })

    const onUpdated = async () => {
      showingAddModal.value = false
      modifyModal.value = {
        showing: false,
        targetId: null
      }
      companies.value = await repository.list()
    }

    const onClickedModify = (company: Company) => {
      modifyModal.value = {
        showing: true,
        targetId: company.key
      }
    }

    const onClickedDelete = (company: Company) => {
      deleteModal.value = {
        showing: true,
        targetName: company.name,
        targetObj: company
      }
    }

    const deleteCompany = async (target: Company) => {
      requestError.value = null
      try {
        await repository.delete(target.key)
        companies.value = await repository.list()
        deleteModal.value = {
          showing: false,
          targetName: null,
          targetObj: null
        }
      } catch (e) {
        buildDefaultRequestErrorHandler(requestError, e).handle()
      }
    }

    return {
      requestError,
      companies,
      showingAddModal,
      modifyModal,
      deleteModal,
      onClickedModify,
      onClickedDelete,
      onUpdated,
      deleteCompany
    }
  }
})
